import { render } from "./TrangChu.vue?vue&type=template&id=119e60c6&scoped=true"
import script from "./TrangChu.vue?vue&type=script&lang=js"
export * from "./TrangChu.vue?vue&type=script&lang=js"

import "./TrangChu.vue?vue&type=style&index=0&id=119e60c6&lang=scss&scoped=true"
import "./TrangChu.vue?vue&type=style&index=1&id=119e60c6&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-119e60c6"]])

export default __exports__